module.exports = "<h1>home</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = 410
// module chunks = 1